import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Components/img/icon_1.svg";
import FormImg from "../Components/img/E-Commerce.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlanPricing from "./PlanPricing";
import ClientCarousel from "./ClientCarousel";


function ServicePage() {
  const fullUrl = window.location.href;
  const [formData, setFormData] = useState({
    service: "",
    name: "",
    number: "",
    email: "",
    dob: "Website",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [services, setServices] = useState([]);
  const [isHumanChecked, setIsHumanChecked] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [checkboxErrors, setCheckboxErrors] = useState({
    isHuman: false,
    terms: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value; // Remove leading and trailing spaces

    if (name === "number") {
      updatedValue = updatedValue.replace(/[^0-9]/g, "").slice(0, 10); // Allow only numbers and limit to 10 digits

      // Remove leading zero
      if (updatedValue.startsWith("0")) {
        updatedValue = updatedValue.slice(1);
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // Validation for phone number
    if (name === "number") {
      if (value.startsWith("0")) {
        setError("Phone number cannot start with 0");
      } else if (updatedValue.length < 10) {
        setError("Phone number must be 10 digits long");
      } else {
        setError("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isHumanChecked || !agreedToTerms) {
      setCheckboxErrors({
        isHuman: !isHumanChecked,
        terms: !agreedToTerms,
      });
      return;
    }
    setLoading(true);

    try {
      const response = await fetch("https://100billionrealestate.com/inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          mobile: formData.number,
          age: formData.email,
          school: formData.service,
          parent_name: "E-Commerce",
          skates_category: fullUrl,
          dob: "Website",
        }),
      });

      if (response.ok) {
        toast.success("Thank you! Our team will contact you soon.", {
          position: "top-center",
          autoClose: 10000, // Close toast after 3 seconds
        });
        setFormData({
          service: "ecommerceWebsite",
          name: "",
          number: "",
          email: "",
          dob: "Website",
        });
      } else {
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 10000, // Close toast after 3 seconds
        });
      }
    } catch (error) {
      toast.error(`${error}`, {
        position: "top-center",
        autoClose: 10000, // Close toast after 3 seconds
      });
    } finally {
      setLoading(false);
    }
  };

  const servicesAllFetch = async () => {
    try {
      const response = await fetch(
        `https://100billionrealestate.com/centerlist/100billiontechservice`
      );
      const res = await response.json();
      console.log(res);
      const extractedServices = res.map((item) => item.center_name);
      setServices(extractedServices);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    servicesAllFetch();
  }, []);
  return (
    <>
      <div className="service-page-hero-main">
        <div className="service-page-hero-container">
          <div className="service-page-hero-flex-direction">
            {/* Update badge */}
            <div className="service-page-hero-update-badge">
              Online ke zamane mein dukaan khol ke baithe ho...?
            </div>

            <div className="service-page-hero-content">
              {/* Main content */}

              <div className="service-heading offer-heading">
                Competitor online hai, aap kab jaoge?{" "}
              </div>
              {/* <span className="yearlyplanplanoffer">With a 1-yr term. You pay ₹ 11,988 today for 1 year.</span> */}
              <div className="margintophbtplanoffer">
                Digital setup shuru karo abhi – sirf{" "}
                <span
                  style={{
                    color: "#007aff",
                    fontSize: "35px",
                    fontWeight: "700",
                  }}
                >
                  ₹999
                </span>
                &nbsp;
                <span
                  className="cutofpriceomsoffer"
                  style={{ color: "#717171" }}
                >
                  ₹1,999
                </span>
                <span className="monthwebsiteoms"> /Mo.</span>{" "}
              </div>

              <Link to="/enquiry">
                <button className="service-button">Get Started</button>
              </Link>
              {
                <Link to="https://api.whatsapp.com/send?phone=918433803555&text=I want to grow my business at ₹999/month">
                  <button className="service-button2">
                    <i
                      className="fa-brands fa-whatsapp"
                      style={{
                        marginRight: "10px",
                        color: "green",
                        fontSize: "20px",
                      }}
                    ></i>
                    +91 8433-803-555
                  </button>
                </Link>
              }
            </div>
            <div></div>
          </div>

          {/* Logo */}
          <div className="service-page-hero-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <PlanPricing />
      <div className="useful">
        <h1>
          In{" "}
          <span
            style={{ color: "#007aff", fontSize: "35px", fontWeight: "700" }}
          >
            ₹999
          </span>
          , you get the following features in E-commerce
        </h1>
        <section className="useful-section">
          <div className="info-box">
            <i className="fas fa-shopping-cart"></i>
            <h3>Online Store</h3>
            <p>
              A complete digital storefront with product listings, cart,
              checkout, and order management.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-box-open"></i>
            <h3>Product Page</h3>
            <p>
              Displays detailed information, images, and pricing for each
              product on the store.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-cart-plus"></i>
            <h3>Add to cart</h3>
            <p>
              Lets users add products to a virtual shopping cart before
              proceeding to checkout.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-credit-card"></i>
            <h3>Checkout Page</h3>
            <p>
              A user-friendly interface for reviewing orders, adding addresses,
              and placing orders.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-university"></i>
            <h3>Payment Gateway</h3>
            <p>
              Secure online payment system supporting multiple methods like UPI,
              cards, and net banking.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-warehouse"></i>
            <h3>Stock Manager</h3>
            <p>
              Manage inventory levels, receive alerts for low stock, and track
              products easily.
            </p>
          </div>

           <div className="info-box">
            <i className="fas fa-users"></i>
            <h3>Customer Manager</h3>
            <p>
              Organize customer data, view order history, and communicate with
              users efficiently.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-bell"></i>
            <h3>Notification Feature</h3>
            <p>
              Sends alerts to users about orders, updates, promotions, or
              messages.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-file-invoice"></i>
            <h3>Auto Invoice System</h3>
            <p>
              Automatically generates and sends invoices for every order placed
              on the site.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-receipt"></i>
            <h3>Auto Receipt System</h3>
            <p>
              Instantly creates and emails payment receipts after successful
              transactions.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-chart-line"></i>
            <h3>CRM System</h3>
            <p>
              Manage leads, customer data, communications, and relationships
              from one dashboard.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-home"></i>
            <h3>Home page</h3>
            <p>
              Engaging landing page to showcase offers, featured products, and
              key business highlights.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-info-circle"></i>
            <h3>About Page</h3>
            <p>
              Introduces your business story, mission, vision, and values to
              build trust with customers.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-phone-alt"></i>
            <h3>Contact us</h3>
            <p>
              Allows users to send inquiries, feedback, or complaints directly
              from your website.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-layer-group"></i>
            <h3>Advanced design</h3>
            <p>
              Modern, responsive, and visually appealing design for a premium
              user experience.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-tools"></i>
            <h3>Full-featured admin panel</h3>
            <p>
              Powerful backend for managing orders, products, users, inventory,
              and settings.
            </p>
          </div>

          <div className="info-box">
            <i className="fab fa-whatsapp"></i>
            <h3>WhatsApp chat support</h3>
            <p>
              Enables direct customer interaction through integrated WhatsApp
              chat button.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-tachometer-alt"></i>
            <h3>Speed and performance optimization</h3>
            <p>
              Ensures fast loading and smooth browsing experience for better
              user retention.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-blog"></i>
            <h3>Blog/News module</h3>
            <p>
              Share updates, articles, and news to engage visitors and improve
              SEO rankings.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-life-ring"></i>
            <h3>Life time free technical support</h3>
            <p>
              Get lifetime assistance for bugs, errors, or feature-related
              issues post-deployment.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-globe"></i>
            <h3>Free Domain & SSL for 1st year</h3>
            <p>
              Includes 1-year domain registration and SSL certificate for secure
              browsing.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-server"></i>
            <h3>Life time free hosting</h3>
            <p>
              No hosting charges ever—your website stays online forever without
              any annual fees.
            </p>
          </div>

         

          <div className="info-box">
            <i className="fas fa-user-lock"></i>
            <h3>User Login and Registration</h3>
            <p>
              Secure login system with signup options and profile management for
              users.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-filter"></i>
            <h3>Product Filter (by category, price, etc.)</h3>
            <p>
              Helps users narrow down products quickly using smart filters and
              sorting tools.
            </p>
          </div>

          <div className="info-box">
            <i className="fas fa-share-alt"></i>
            <h3>Product Share Feature</h3>
            <p>
              Allows users to share product links on WhatsApp, Facebook,
              Instagram, and more.
            </p>
          </div>


          <div className="info-box">
            <i className="fas fa-file-invoice-dollar"></i>
            <h3>Billing and Transaction History Page</h3>
            <p>
              Shows users their complete order billing and past transactions in
              one place.
            </p>
          </div>

          
        </section>
      </div>
       <PlanPricing />
      <ClientCarousel />
      <section className="form-area">
        <div className="illustration">
          <img src={FormImg} alt="E-commerce illustration" />
        </div>
        <div className="form-container">
          <form id="multiStepForm" onSubmit={handleSubmit}>
            <div className="form-step active" id="formStep1">
              <h2>Get Started Today</h2>
              <br />
              <div className="error" id="formStep1Error"></div>

              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="" disabled selected>
                  -- Select a Service --
                </option>
                {services.map((service, index) => (
                  <option key={index} value={service}>
                    {service}
                  </option>
                ))}
                {/* <option value="websiteDevelopment">Website Development</option>
                                <option value="appDevelopment">App Development</option>
                                <option value="ecommerceWebsite">E-commerce Website</option>
                                <option value="googleAds">Google Ads</option>
                                <option value="metaAds">Meta Ads</option>
                                <option value="digitalMarketing">Digital Marketing</option> */}
              </select>

              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />

              <label htmlFor="number">Phone Number</label>
              <input
                type="tel"
                id="number"
                name="number"
                value={formData.number}
                onChange={handleChange}
                required
                placeholder="Enter your phone number"
              />
              {error && (
                <p className="error-message-form error-service-message">
                  {error}
                </p>
              )}

              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your email address"
              />

              <div className="four-servicepagemainweb-page">
                <div className="form-mainfieldcheck-hbt">
                  <div className="form-fieldcheck-hbt">
                    <input
                      type="checkbox"
                      id="isHuman"
                      checked={isHumanChecked}
                      onChange={(e) => {
                        setIsHumanChecked(e.target.checked);
                        setCheckboxErrors((prev) => ({
                          ...prev,
                          isHuman: false,
                        }));
                      }}
                    />

                    <p className="form-terms-hbt">
                      Please check the box to confirm you're human
                    </p>
                  </div>
                  {checkboxErrors.isHuman && (
                    <p className="error-message-form">
                      Please confirm you're human
                    </p>
                  )}
                  <div className="form-fieldcheck-hbt">
                    <input
                      type="checkbox"
                      id="terms"
                      checked={agreedToTerms}
                      onChange={(e) => {
                        setAgreedToTerms(e.target.checked);
                        setCheckboxErrors((prev) => ({
                          ...prev,
                          terms: false,
                        }));
                      }}
                    />
                    <p className="form-terms-hbt">
                      By submitting, you agree to our{" "}
                      <span
                        onClick={() =>
                          window.open(
                            "https://100billiontech.com/terms-and-conditions",
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                        style={{ cursor: "pointer", color: "#4685f6" }}
                      >
                        terms and conditions
                      </span>
                    </p>
                  </div>
                  {checkboxErrors.terms && (
                    <p className="error-message-form">
                      You must agree to the terms
                    </p>
                  )}
                </div>
              </div>

              <div className="form-actions-hbt">
                <button type="submit" disabled={loading}>
                  {loading ? <div className="loader"></div> : "Get started"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>

      <div id="three-js-background"></div>

      <section class="process">
        <h1>Our E-Commerce Website Development Process</h1>
        <div class="process-container">
          <div class="process-card">
            <div class="process-number">1</div>
            <i class="fas fa-search process-icon"></i>
            <h2>Discovery</h2>
            <p>
              Understand your business goals, target audience, and market needs
              to tailor the e-commerce strategy.
            </p>
          </div>
          <div class="process-card">
            <div class="process-number">2</div>
            <i class="fas fa-pencil-ruler process-icon"></i>
            <h2>Design</h2>
            <p>
              Create a user-friendly, visually appealing design that enhances
              the shopping experience.
            </p>
          </div>
          <div class="process-card">
            <div class="process-number">3</div>
            <i class="fas fa-code process-icon"></i>
            <h2>Development</h2>
            <p>
              Build the e-commerce site with essential features like product
              listings, cart functionality, and secure payment options.
            </p>
          </div>
          <div class="process-card">
            <div class="process-number">4</div>
            <i class="fas fa-cogs process-icon"></i>
            <h2>Integration</h2>
            <p>
              Integrate with third-party services such as payment gateways,
              shipping providers, and inventory management systems.
            </p>
          </div>
          <div class="process-card">
            <div class="process-number">5</div>
            <i class="fas fa-bug process-icon"></i>
            <h2>Testing</h2>
            <p>
              Test the website for functionality, performance, and security to
              ensure a smooth user experience.
            </p>
          </div>
          <div class="process-card">
            <div class="process-number">6</div>
            <i class="fas fa-rocket process-icon"></i>
            <h2>Launch</h2>
            <p>
              Deploy the site and monitor its performance to ensure it meets
              your business goals and provides an optimal user experience.
            </p>
          </div>
        </div>
      </section>

      <div className="faq-container">
        <h1>Ecommerce Website Service - FAQ</h1>
        {[
          {
            question:
              "What services does 100Billion Tech offer for e-commerce websites?",
            answer:
              "We offer a range of e-commerce services including custom website design and development, payment gateway integration, product catalog setup, inventory management, and ongoing support. Our team ensures that your e-commerce site is tailored to your business needs and goals.",
          },
          {
            question: "How long does it take to develop an e-commerce website?",
            answer:
              "The development timeline for an e-commerce website depends on the complexity and features required. On average, it can take anywhere from 6 to 12 days from initial planning to launch. We provide a detailed timeline based on your specific requirements.",
          },
          {
            question: "Can you help with product and inventory management?",
            answer:
              "Yes, we can integrate your e-commerce website with inventory management systems to streamline product management, track stock levels, and automate updates. This ensures that your inventory is accurately reflected on your website.",
          },
          {
            question: "Do you offer SEO services for e-commerce websites?",
            answer:
              "Yes, we provide additional SEO services to improve your e-commerce website's visibility in search engine results. This includes keyword optimization, on-page SEO, technical SEO, and ongoing performance monitoring to drive organic traffic to your site.",
          },
          {
            question:
              "What payment methods can be integrated into the e-commerce site?",
            answer:
              "We can integrate various payment methods into your e-commerce website, including UPI, credit/debit cards, PayPal, Stripe, and other payment gateways. This ensures that your customers have multiple payment options for a convenient shopping experience.",
          },
          {
            question:
              "How do you ensure the security of the e-commerce website?",
            answer:
              "We implement robust security measures including SSL certificates, secure payment processing, and regular security updates to protect your e-commerce website from threats and ensure the safety of your customers' data.",
          },
          {
            question: "Can you help with ongoing maintenance and updates?",
            answer:
              "Yes, we offer free ongoing maintenance services to keep your e-commerce website updated, secure, and running smoothly. This includes software updates, security patches, and performance optimization.",
          },
          {
            question:
              "What should I prepare before starting the e-commerce website project?",
            answer:
              "Before starting, you should prepare key details such as your business goals, target audience, product information, branding assets (logos, images), and any specific features or functionalities you need. This will help streamline the development process and ensure your website meets your expectations.",
          },
        ].map((faq, index) => (
          <div className="faq-item" key={index}>
            <div
              className="faq-question"
              onClick={(e) => toggleFaq(e.currentTarget)}
            >
              {faq.question}
              <i className="icon fas fa-chevron-down"></i>
            </div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </>
  );
}

// JS function for toggling FAQ
function toggleFaq(element) {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    if (item !== element.parentElement) {
      item.classList.remove("active");
    }
  });

  element.parentElement.classList.toggle("active");
}

export default ServicePage;
